import _ from 'underscore';
import Backbone from 'backbone';
import CachePolicies from 'utils/sync/CachePolicies';
import 'utils/sync/ConnectSync';

var defaultSync = Backbone.sync;

var memoryCache = [];

function getCachePolicy(url) {
    for (var regEx in CachePolicies) {
        if (CachePolicies.hasOwnProperty(regEx)) {
            if (url.match(regEx) || url.match('/proxy' + regEx)) {
                return CachePolicies[regEx];
            }
        }
    }

    return null;
}

function createCacheEntry(url, resp) {
    return {
        url: url,
        resp: resp,
        timestamp: new Date().getTime(),
        pendingUpdate: false,
        waitList: []
    };
}

function storeCacheEntry(cachePolicy, cacheEntry) {
    if (cachePolicy.persistToDisk) {
        try {
            localStorage[cacheEntry.url] = JSON.stringify(cacheEntry);
        } catch (err) {
            // Must be full.  Dirty fix, just empty it.
            localStorage.clear();
        }
    } else {
        var entryIndex = memoryCache.indexOf(cacheEntry);
        if (entryIndex > -1) {
            // update entry
            memoryCache[entryIndex] = cacheEntry;
        } else {
            memoryCache.push(cacheEntry);
        }
    }
}

function retrieveCacheEntry(cachePolicy, url) {
    if (cachePolicy.persistToDisk) {
        var item = localStorage[url];
        if (item) {
            return JSON.parse(item);
        }
    } else {
        return _.find(memoryCache, function(_cacheEntry) {
            return _cacheEntry.url === url;
        });
    }

    return null;
}

function removeFromCache(cachePolicy, cacheEntry) {
    // If there are requests waiting, these should time out.
    if (cacheEntry.pendingUpdate) {
        _.each(cacheEntry.waitList, function(request) {
            request.error('Timeout exceeded.');
        });
    }

    if (cachePolicy.persistToDisk) {
        localStorage.removeItem(cacheEntry.url);
    } else {
        memoryCache = _.reject(memoryCache, function(_cacheEntry) {
            return _cacheEntry === cacheEntry;
        });
    }
}

function cacheIsExpired(cachePolicy, cacheEntry) {
    var age = new Date().getTime() - cacheEntry.timestamp;

    // Pending updates can't expire, unless they are older than 2 minutes, which we consider to be a timeout.
    if (cacheEntry.pendingUpdate && age > 120000) {
        return true;
    } else {
        return age > cachePolicy.cacheTimeoutMs;
    }
}

Backbone.sync = function(method, model, options) {
    if (method == 'read') {
        var url = options.url || _.result(model, 'url');

        if (url) {
            var cachePolicy = getCachePolicy(url);

            if (cachePolicy && !options.ignoreCache) {
                var cacheEntry = retrieveCacheEntry(cachePolicy, url);
                if (cacheEntry) {
                    if (!cacheIsExpired(cachePolicy, cacheEntry)) {
                        if (cacheEntry.pendingUpdate) {
                            cacheEntry.waitList.push({
                                success: options.success,
                                error: options.error
                            });
                        } else {
                            options.success(cacheEntry.resp);
                        }

                        return;
                    } else {
                        removeFromCache(cachePolicy, cacheEntry);
                    }
                }

                cacheEntry = createCacheEntry(url, null);
                cacheEntry.pendingUpdate = true;
                storeCacheEntry(cachePolicy, cacheEntry);

                var success = options.success;
                options.success = function(resp) {
                    success(resp);

                    _.each(
                        cacheEntry.waitList,
                        function(request) {
                            request.success(resp);
                        },
                        this
                    );

                    cacheEntry.resp = resp;
                    cacheEntry.pendingUpdate = false;
                    cacheEntry.waitList = [];
                    storeCacheEntry(cachePolicy, cacheEntry);
                };

                var error = options.error;
                options.error = function(resp) {
                    error(resp);

                    _.each(
                        cacheEntry.waitList,
                        function(request) {
                            request.error(resp);
                        },
                        this
                    );

                    cacheEntry.pendingUpdate = false;
                    cacheEntry.waitList = [];
                    removeFromCache(cachePolicy, cacheEntry);
                };
            }
        }
    }

    return defaultSync(method, model, options); // return a Promise
};

export default Backbone.sync;
